"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetWorkerFacilityService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const web_consensus_1 = require("@branch-ts/web-consensus");
const fat_sharedWorker_1 = require("./service.Verset/fat.sharedWorker");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
let VersetWorkerFacilityService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)({
            ambient: false,
        })];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetWorkerFacilityService = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetWorkerFacilityService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        constructor(config) {
            this.config = config;
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
            this.closed = false;
        }
        async getTrailResource() {
            if (this.closed)
                throw new Error("Worker facility closed");
            await this.connectWorker();
            const lease = this.deps.VersetRequireLoginService.agreement;
            return this.setup.sharedWorkerClient.getTrailResource({ scope: JSON.stringify([lease.vendor, lease.signer]) });
        }
        async connectWorker() {
            try {
                return await this.setup.setup();
            }
            catch (error) {
                if (!this.closed) {
                    // Old workers can survive a page refresh while another tab still owns them.
                    // Show recovery without delaying or replacing the original startup failure.
                    this.restartNotice ??= web_consensus_1.CommonUI.show({
                        title: "Restart your browser to continue",
                        text: "Verset couldn't finish starting. An earlier version may still be running in another tab or window.\n\nFully quit your browser, including all windows, then reopen it and return to Verset. Refreshing this page or closing only this tab may not be enough.\n\nBefore quitting, copy any unsaved work you need to keep.",
                    }).catch(noticeError => {
                        console.warn("Could not display browser restart notice", noticeError);
                    }).finally(() => { this.restartNotice = undefined; });
                }
                throw error;
            }
        }
        async initialize() {
            const sharedWorkerSetup = (0, fat_sharedWorker_1.FatSharedWorkerSetup)({
                jsUrl: this.config.sharedWorkerUrl,
                version: this.config.sharedWorkerVersion,
            });
            this.setup = sharedWorkerSetup;
            await this.connectWorker().then((self) => {
                this.sessionArbitratorAccessProvider = self.sharedWorkerClient.arbitratorAccessProvider;
                this.sessionIdpsSpace = self.sharedWorkerClient.idpsSpace;
            });
            this.unregisterLogout = web_consensus_1.LogoutMechanism.registerAction("Verset.sharedWorker", () => this.close(), { phase: "cleanup" });
        }
        close() { this.closed = true; this.setup?.close(); }
        destroy() { this.unregisterLogout?.(); this.close(); }
    };
    return VersetWorkerFacilityService = _classThis;
})();
exports.VersetWorkerFacilityService = VersetWorkerFacilityService;
